import isBefore from 'date-fns/is_before';
import isAfter from 'date-fns/is_after';
import getYear from 'date-fns/get_year';

import { partialRight } from 'ramda';

import {
  formatDateString,
  parseDateString,
  formatDate as formatDateIgnoringYear,
} from 'utils/formatString';

import {
  UI_DATE_FORMAT,
  NOTIFICATION_MESSAGE_TYPE,
  PERMISSION_MESSAGE_TYPE,
  NEW_NOTIFICATION_STATUS,
  UNREAD_NOTIFICATION_STATUS,
  READ_NOTIFICATION_STATUS,
} from './constants';

export const dateComparator = (firstDate, secondDate) => {
  if (isBefore(parseDateString(firstDate), parseDateString(secondDate))) {
    return -1;
  }

  if (isAfter(parseDateString(firstDate), parseDateString(secondDate))) {
    return 1;
  }

  return 0;
};

export const messageComparator = (a, b, dataField) => {
  if (dataField === 'date') {
    return dateComparator(a[dataField], b[dataField]);
  }

  if (a[dataField] < b[dataField]) {
    return -1;
  }

  if (a[dataField] > b[dataField]) {
    return 1;
  }

  return 0;
};

export const isNotification = (message) => message.messageType === NOTIFICATION_MESSAGE_TYPE;
export const isPermissionMessage = (message) => message.messageType === PERMISSION_MESSAGE_TYPE;

export const isNotificationStatusNew = (message) => message.statusCode === NEW_NOTIFICATION_STATUS
  || message.statusCode === UNREAD_NOTIFICATION_STATUS;

export const isNotificationUnread = (message) => isNotification(message) && isNotificationStatusNew(message);

export const setNotificationRead = (message) => ({
  ...message,
  statusCode: READ_NOTIFICATION_STATUS,
});

export const convertAPIDateToUIDate = partialRight(formatDateString, [UI_DATE_FORMAT]);

export const isDetailsRequired = (message) => message.isHelpdesk && !message.comments;

export const isExpandable = (message) => message.text || message.attachment || message.isHelpdesk;

export const defaultComparator = (a, b) => {
  if (isNotificationUnread(a) && isNotificationUnread(b)) {
    return -1 * dateComparator(a.date, b.date);
  }

  if (isNotificationUnread(a)) {
    return -1;
  }

  if (isNotificationUnread(b)) {
    return 1;
  }

  return -1 * dateComparator(a.date, b.date);
};

export const formatDate = (date) => {
  const currentYear = getYear(new Date());
  const targetYear = getYear(parseDateString(date));
  const yearPostfix = currentYear === targetYear ? '' : ' года';

  return `${formatDateIgnoringYear(date)}${yearPostfix}`;
};
